<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="(size*21)/24"
    viewBox="0 0 24 21"
  ><g><g><g><path
    :fill="color"
    d="M18.754 18.633H5.913a3.193 3.193 0 0 1-2.708-4.874l6.42-10.29a3.174 3.174 0 0 1 2.709-1.504c1.108 0 2.12.562 2.707 1.504l6.421 10.29a3.193 3.193 0 0 1-2.708 4.874zm3.79-5.55l-6.42-10.29A4.442 4.442 0 0 0 12.334.69a4.442 4.442 0 0 0-3.79 2.104l-6.421 10.29a4.454 4.454 0 0 0-.675 2.36 4.47 4.47 0 0 0 4.465 4.465h12.841a4.47 4.47 0 0 0 4.465-4.465c0-.837-.233-1.653-.675-2.36z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="20"
    d="M18.754 18.633H5.913a3.193 3.193 0 0 1-2.708-4.874l6.42-10.29a3.174 3.174 0 0 1 2.709-1.504c1.108 0 2.12.562 2.707 1.504l6.421 10.29a3.193 3.193 0 0 1-2.708 4.874zm3.79-5.55l-6.42-10.29A4.442 4.442 0 0 0 12.334.69a4.442 4.442 0 0 0-3.79 2.104l-6.421 10.29a4.454 4.454 0 0 0-.675 2.36 4.47 4.47 0 0 0 4.465 4.465h12.841a4.47 4.47 0 0 0 4.465-4.465c0-.837-.233-1.653-.675-2.36z"
  /></g><g><path
    :fill="color"
    d="M11.696 7.706h1.275v4.507h-1.275z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="20"
    d="M11.696 7.706v0h1.275v4.507h-1.275v0z"
  /></g><g><path
    :fill="color"
    d="M11.696 13.488h1.275v1.276h-1.275z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="20"
    d="M11.696 13.488v0h1.275v1.276h-1.275v0z"
  /></g></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
